import React from "react";
import PropTypes from "prop-types";
import { StoryCardsContainer } from "./StoryCards.styled";
import { useTranslation } from "react-i18next";
import StoryCard from "components/Cards/StoryCard/StoryCard";

const StoryCards = ({ data, children }) => {
  const { t } = useTranslation();
  return (
    <StoryCardsContainer>
      {data?.map((item, index) => (
        <StoryCard
          key={index}
          title={t(item.title)}
          image={item.image}
          badges={item.badges?.map((x) => t(x))}
          bgColor={item.bgColor}
          highlightColor={item.highlightColor}
          link={item.link}
        >
          {children}
        </StoryCard>
      ))}
    </StoryCardsContainer>
  );
};

StoryCards.propTypes = {
  children: PropTypes.node,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.string,
      badges: PropTypes.array,
      bgColor: PropTypes.string,
      highlightColor: PropTypes.string,
      children: PropTypes.node,
      link: PropTypes.string,
    })
  ),
};
export default StoryCards;
